import React from 'react'

function NotFound() {
  return (
    <div>404 NotFound</div>
  )
}

export default NotFound